import getApiInstance from 'data/common/ApiCallGenerique';
import { Logger } from 'data/common';
import api from './api';
import getSocketMiddlewareInstance from '../../common/SocketMiddleware';

const apiCaller = getApiInstance();

function getSecurities() {
    return dispatch => {
        return apiCaller
            .call(api.getAllSecurities())
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: 'MYFHE__FHEPRODUCT_SET_SECURITIES',
                        Securities: data.Securities
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setMyFHESecurities - ', error);
                throw error;
            });
    };
}
function getSecurityDetails(SecurityId) {
    return dispatch => {
        return apiCaller
            .call(api.getSecurityDetails(SecurityId))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: 'MYFHE__FHEPRODUCT_SET_SECURITY_DETAILS',
                        SecurityId: data.SecurityDetails.macAddress,
                        SecurityDetails: data.SecurityDetails
                    });
                }

                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setMyFHESecurityDetails - ', error);
                throw error;
            });
    };
}
function refreshSecurityStatus(SecurityMac) {
    return () => {
        return getSocketMiddlewareInstance()
            .FHEProductCheckStatus('Security', SecurityMac)
            .catch(error => {
                Logger.log('dataActions: refreshMyFHESecurityStatus - ', error);
                throw error;
            });
    };
}
function dissociateSecurityUser(SecurityMac, userId) {
    return () => {
        return getSocketMiddlewareInstance()
            .FHEProductDissociateUser('Security', SecurityMac, userId)
            .catch(error => {
                Logger.log('dataActions: dissociateSecurityUser - ', error);
                throw error;
            });
    };
}
function dissociateSecurityUserAndSwitchMaster(SecurityMac, userId, masterId) {
    return () => {
        return getSocketMiddlewareInstance()
            .FHEProductDissociateUserAndSwitchMaster('Security', SecurityMac, userId, masterId)
            .catch(error => {
                Logger.log('dataActions: dissociateSecurityUserAndSwitchMaster - ', error);
                throw error;
            });
    };
}
function switchSecurityMaster(SecurityMac, userId) {
    return () => {
        return getSocketMiddlewareInstance()
            .FHEProductMasterSwitch('Security', SecurityMac, userId)
            .catch(error => {
                Logger.log('dataActions: switchMyFHESecurityMaster - ', error);
                throw error;
            });
    };
}

export {
    getSecurities,
    getSecurityDetails,
    refreshSecurityStatus,
    dissociateSecurityUser,
    dissociateSecurityUserAndSwitchMaster,
    switchSecurityMaster
};



// WEBPACK FOOTER //
// ./environments/myfhe/data/Security/actions.js